/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
//Standard libraries
import styled from "styled-components";
import { MenuBlock } from "../components/menu-block";
import { MenuBlocks } from "../constants/menu-blocks";
import { getAllowedRoutes } from "../helpers/user-session";
import { useCSRValue } from "../context";
import { useEffect, useState } from "react";

const StyledNav = styled.nav`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
  font-weight: 800;
  font-size: 18px;
  .menu_block_title {
    font-weight: bold;
    padding-left: 15px;
  }
  .menu__block-item-title {
    font-weight: 800;
    font-size: 13px;
  }
`;

export default function Menu() {
  const [menuBlocks, setMenuBlocks] = useState<any[]>([]);
  const { csr } = useCSRValue();
  const allowedRoutes = getAllowedRoutes();

  useEffect(() => {
    const filteredMenuBlocks = MenuBlocks.map((block) => ({
      ...block,
      items: block.items.filter((item) =>
        allowedRoutes.some(
          (route) => route.entitlementName === item.link.replace("/", "")
        )
      ),
    }));
    setMenuBlocks(filteredMenuBlocks);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [csr]);

  return (
    <StyledNav className="container">
      <p className="menu_block_title">Módulo de órdenes</p>
      {menuBlocks.map((block, index) => (
        <MenuBlock key={index} block={block} />
      ))}
    </StyledNav>
  );
}
